/**
 * Firebase Analytics (GA4) for the web app — same property as mobile, separate
 * Web stream. Uses the mobile event names with a `platform: 'web'` param. Off in dev.
 */
import { getAnalytics, isSupported, logEvent, setUserId, setUserProperties, type Analytics } from 'firebase/analytics'
import { app } from './firebase'

const ENABLED = !import.meta.env.DEV

let analytics: Analytics | null = null

if (ENABLED) {
  isSupported()
    .then((ok) => {
      if (ok) analytics = getAnalytics(app)
    })
    .catch(() => {})
}

export function track(eventName: string, params?: Record<string, unknown>): void {
  if (!analytics) return
  try {
    logEvent(analytics, eventName, { platform: 'web', ...params })
  } catch {
    /* never let analytics break the app */
  }
}

export function trackPageView(path: string): void {
  track('page_view', { page_path: path, page_location: window.location.href, page_title: path })
}

export function identifyUser(uid: string | null, isPremium?: boolean): void {
  if (!analytics) return
  try {
    setUserId(analytics, uid)
    if (uid != null && isPremium !== undefined) setUserProperties(analytics, { is_premium: String(isPremium) })
  } catch {
    /* ignore */
  }
}
